import { createClient } from "contentful";
import {
  WILDEST_CONTENTFUL_SPACE_ID,
  WILDEST_CONTENTFUL_PREVIEW_ACCESS_TOKEN,
  WILDEST_CONTENTFUL_PUBLIC_ACCESS_TOKEN,
  WILDEST_CONTENTFUL_ENVIRONMENT,
} from "lib/constants";
import { random } from "lodash";
import router from "next/router";

let space;

export default function contentfulSpace() {
  if (space) {
    return space;
  }

  let contentfulPreview = false;
  if (typeof window !== "undefined") {
    const { preview } = router.query;
    contentfulPreview = preview;
  }

  const clientPromise = createClient({
    space: WILDEST_CONTENTFUL_SPACE_ID,
    environment: WILDEST_CONTENTFUL_ENVIRONMENT,
    accessToken: contentfulPreview
      ? WILDEST_CONTENTFUL_PREVIEW_ACCESS_TOKEN
      : WILDEST_CONTENTFUL_PUBLIC_ACCESS_TOKEN,
    host: contentfulPreview ? "preview.contentful.com" : "cdn.contentful.com",
  });

  space = clientPromise;
  return space;
}

export const getRandomAndUniqueArticles = (payloadItems) => {
  const randomAndUniqueArticles = [];

  // loop through all the Good Friend authored articles in the CMS/Contentful
  for (let i = 0; i < payloadItems.length; i++) {
    // get a random article
    const articleItem = payloadItems[random(0, 15)];

    if (
      // this article is not in the array
      !randomAndUniqueArticles.includes(articleItem) &&
      // the article array length is less than the maxNumberOfItemsToBeReturn
      randomAndUniqueArticles.length < 4
    ) {
      // push it
      randomAndUniqueArticles.push(articleItem);
    }
  }

  // return the array of 4 random and unique articles
  return randomAndUniqueArticles;
};

export const cLoadArticles = async () => {
  space = contentfulSpace();
  return space
    .getEntries({
      content_type: "article",
      "fields.goodFriend": true,
      limit: 16,
      include: 1,
    })
    .then((payload) => getRandomAndUniqueArticles(payload.items));
};
